import axios from "axios";
import { GridColDef } from '@mui/x-data-grid';
import "i18n/config";
import i18next from "i18next";

export const get = async (row:any) => {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+row.id+"/department");
    return response.data;
};

export const update = async (row:any, masterRow?:any) => {
  let response = null;
  row.rule_type = row.rule_type==='Domain'?0:1;
  if(!row.id) {
      response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id+"/department/store",row);
  } else {
      response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id+"/department/update/"+row.id,row);
  }
  return response.data;
};

export const destroy = async (id:any, masterRow?:any) => {
  let response = null;
  response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/organization/"+masterRow.id+"/department/delete/"+id);
  return response.data;
};

export async function getColumns(locale: string) {
  i18next.changeLanguage(locale);
  return [
    { 
      field: 'id', 
      headerName: 'ID',
      width: 90
    },
    {
      field: 'name',
      headerName: i18next.t('Name'),
      flex: 1,
      editable: true,
    },
    {
      field: 'id_manager',
      headerName: i18next.t('Manager'),
      flex: 1,
      editable: true,
      type: 'singleSelect',
      valueOptions: params => params.row?.users?.map((user:any) => {return {'value': user.id, 'label': user.name}}),
      valueGetter: params => params.row.id_manager || '',
    }
  ] as GridColDef[];
};